import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { configData } from '../config';

// As on the live site, every page names a picture for shared links (og:image): the SMWW globe,
// unless the page names its own (Page.js: a course's or conference's Image field). A certificate
// page sets all its Open Graph tags itself (react-helmet-async), so it gets none here.
function DefaultOgImage() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/certificate/')) return null;
  return (
    <Helmet>
      <meta property="og:image" content={configData.DEFAULT_OG_IMAGE} />
    </Helmet>
  );
}

export default DefaultOgImage;
